import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useNavigationModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      "& .MuiDialog-paper": {
        borderRadius: 16,
        padding: theme.spacing(1),
        maxWidth: 480,
      },
      "& .MuiTypography-h6": {
        color: theme.palette.primary.main,
        fontWeight: 600,
        fontSize: "18px !important",
        textAlign: "center",
      },
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      padding: theme.spacing(2),
    },
    image: {
      width: 220,
      height: 220,
    },
    message: {
      color: theme.palette.text.primary,
      fontSize: "10px",
      lineHeight: 1.1,
    },
    dialogActions: {
      padding: theme.spacing(2, 3, 3, 3),
      justifyContent: "center",
      gap: theme.spacing(2),
    },
    acceptButton: {
      minWidth: 100,
      borderRadius: 50,
      textTransform: "none",
      fontWeight: 500,
    },
    navigateButton: {
      minWidth: 120,
      borderRadius: 8,
      textTransform: "none",
      fontWeight: 600,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  })
);
